module.exports = __webpack_public_path__ + "img/1745567661_JDNx.1a6fe431.jpg";